import { api } from "./api";

export async function uploadBlob(blob, filename) {
  const fd = new FormData();
  fd.append("file", new File([blob], filename, { type: blob.type || "application/octet-stream" }));
  const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}

// Captures a still frame from a video Blob and returns a JPEG Blob (or null on failure).
export function captureVideoPoster(source) {
  return new Promise((resolve) => {
    const url = typeof source === "string" ? source : URL.createObjectURL(source);
    const video = document.createElement("video");
    video.preload = "auto";
    video.muted = true;
    video.playsInline = true;
    video.src = url;
    const cleanup = () => { if (typeof source !== "string") URL.revokeObjectURL(url); };
    video.onloadeddata = () => {
      const t = isFinite(video.duration) && video.duration > 0 ? Math.min(0.5, video.duration / 2) : 0.1;
      try { video.currentTime = t; } catch (e) { cleanup(); resolve(null); }
    };
    video.onseeked = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth || 640;
        canvas.height = video.videoHeight || 360;
        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((b) => { cleanup(); resolve(b); }, "image/jpeg", 0.8);
      } catch (e) { cleanup(); resolve(null); }
    };
    video.onerror = () => { cleanup(); resolve(null); };
  });
}
